import { Collapse } from 'antd';
import React, { FC } from 'react';
import IconChevronDown from '../../layouts/contacts-layout/assets/chevron-down.svg';
import './contact-card.scss';
import { localize } from '/react4xp/mixins/helpers';

const ContactCard: FC = (page: any) => {
    const role = page.role?._selected || 'management';
    return (
        <div className="contact-card">
            <div>
                <div className="contact-card-image-box">
                    <div
                        className="contact-card__image"
                        style={{
                            background: `url(${page.src}) 100% 100% / cover no-repeat`,
                        }}
                    ></div>
                </div>
                {!!page.receptionSchedule && (
                    <Collapse
                        expandIconPosition="right"
                        expandIcon={({ isActive }) =>
                            isActive ? (
                                <IconChevronDown className="icon-active" />
                            ) : (
                                <IconChevronDown />
                            )
                        }
                        items={[
                            {
                                key: '1',
                                label: localize(
                                    'contact-card-reception-dates',
                                    page.commonTranslations
                                ),
                                children: (
                                    <div className="contact-card__schedule">
                                        {page.receptionSchedule.map(({ label }) => (
                                            <span>{label}</span>
                                        ))}
                                    </div>
                                ),
                            },
                        ]}
                    />
                )}
            </div>
            <div className="contact-card-info-box">
                <p className="contact-card__name">{page.name}</p>
                <p className="contact-card__description">{page.description}</p>

                {page.directions && (
                    <div className="contact-card__description">
                        <p className="contact-card__label">Основные направления:</p>
                        <div dangerouslySetInnerHTML={{ __html: page.directions }} />
                    </div>
                )}

                <p className="contact-card__biography">
                    {!!(role === 'management') && (
                        <a href={page.myUrl + page.bioLink}>
                            {localize('contact-card-bio', page.commonTranslations)}
                        </a>
                    )}
                </p>

                {!!page.contactPhone && (
                    <>
                        <p className="contact-card__label">
                            {localize('contact-card-phone-number', page.commonTranslations)}
                        </p>
                        <span className="colored">{page.contactPhone}</span>
                    </>
                )}

                {!!page.email && (
                    <>
                        <p className="contact-card__label contact-card__email">
                            {localize('contact-card-email', page.commonTranslations)}
                        </p>
                        <span className="colored">{page.email}</span>
                    </>
                )}
            </div>
        </div>
    );
};

export default (props) => <ContactCard {...props} />;
